import React from 'react';
import { SparkSearchContext } from 'contexts/SparkSearchContext';
import { useDebounce } from 'hooks/common';

export type SparkFilterType = {
  search: string;
  category: string;
  advanced: string;
};
const INITIAL_FILTER = {
  search: '',
  category: 'all',
  advanced: '',
};
type SparkSearchContextProviderProps = {
  children: React.ReactNode;
};
const SparkSearchContextProvider = ({
  children,
}: SparkSearchContextProviderProps) => {
  const [filter, setFilter] = React.useState<SparkFilterType>(INITIAL_FILTER);
  const debounce = useDebounce();
  const changeFilter = debounce(setFilter, 500);

  const handleQueryChange = React.useCallback(
    (value: string) => {
      changeFilter((prev) => ({ ...prev, search: value }));
    },
    [changeFilter]
  );

  const handleFilterButtonClick = (categoryID: string) => {
    setFilter((prev) => ({ ...prev, category: categoryID }));
  };

  const getIsFilterButtonActive = (optionsValue: string): boolean => {
    if (optionsValue === 'all' && !filter.category) {
      return true;
    }
    return filter.category === optionsValue;
  };

  const contextValue = {
    getIsFilterButtonActive,
    handleFilterButtonClick,
    handleQueryChange,
    filter,
  };
  return (
    <SparkSearchContext.Provider value={contextValue}>
      {children}
    </SparkSearchContext.Provider>
  );
};

export default SparkSearchContextProvider;
